/**
 * EventBadge — the small standing chip on a calendar event (BON-146), e.g.
 * "Current" on the workshop a booking is being moved off.
 *
 * Deliberately NOT the disabled-reason treatment. A reason is a refusal and
 * renders in warn colour on the seats line; a badge is an identity — the CSR
 * uses it to judge how far the new date moves the customer — so it stays a
 * neutral chip that reads as a label rather than as a failure, even though the
 * event carrying it is also disabled.
 */
export interface EventBadgeProps {
  label: string;
}

export function EventBadge({ label }: EventBadgeProps) {
  return (
    <span
      style={{
        flex: '0 0 auto',
        fontSize: 8.5,
        fontWeight: 800,
        letterSpacing: '.05em',
        textTransform: 'uppercase',
        lineHeight: 1.7,
        padding: '0 5px',
        borderRadius: 999,
        border: '1px solid var(--nb-border-2)',
        color: 'var(--nb-subtle)',
        background: 'var(--nb-bg-2, rgba(0,0,0,.04))',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
